import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import * as models from './models'
import type { TypeParams } from './types'

@ngCore.Injectable({ providedIn: 'root' })
export class Api implements ec.models.Api<TypeParams> {
  public list = ec.models.Api.list.using.onlyFilter<TypeParams>(
    (_, { filter }) => {
      const ctx = filter?.additionalFilters
      return ctx?.appId && ctx?.zoneId && ctx?.tenantId
        ? gql.queries.inApp.execute({
            appId: ctx.appId,
            tenantId: ctx.tenantId,
            zoneId: ctx.zoneId,
          })
        : ctx?.zoneId && ctx?.tenantId
          ? gql.queries.inZone.execute({
              tenantId: ctx.tenantId,
              zoneId: ctx.zoneId,
            })
          : ctx?.tenantId
            ? gql.queries.inTenant.execute({ tenantId: ctx.tenantId })
            : rxjs.of([])
    },
  )

  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('userName', {
        name: 'User Name',
      }),
      ec.models.Attribute.fromKey<TypeParams>('agentName', { name: 'Agent' }),
      {
        getValueFrom: models.AgentAssignment.getAccessFlagsLabel,
        id: models.AgentAssignment.ACCESS_FLAGS_ATTRIBUTE_ID,
        name: 'Access Flags',
      },
    ])
}
